import ReducerApp, { AppState } from '~/Reducers/ReducerApp';
import ReducerAccount, { AccountState } from '~/Reducers/ReducerAccount';
import ReducerAuction, { AuctionState } from '~/Reducers/ReducerAuction';
import ReducerWSMart, { WSMartState } from '~/Reducers/ReducerWSMart';
import ReducerLootbox, { LootboxState } from '~/Reducers/ReducerLootbox';
import ReducerSeaBattle, { SeaBattleState } from '~/Reducers/ReducerSeaBattle';
import ReducerFeatures, { FeaturesState } from '~/Reducers/ReducerFeatures';
import ReducerTradeIn, { TradeInState } from '~/Reducers/ReducerTradeIn';
import { combineReducers } from 'redux';

const reducers = {
    ReducerApp,
    ReducerAccount,
    ReducerAuction,
    ReducerWSMart,
    ReducerLootbox,
    ReducerFeatures,
    ReducerSeaBattle,
    ReducerTradeIn,
};

export interface State {
    ReducerApp: AppState;
    ReducerAccount: AccountState;
    ReducerAuction: AuctionState;
    ReducerWSMart: WSMartState;
    ReducerLootbox: LootboxState;
    ReducerFeatures: FeaturesState;
    ReducerSeaBattle: SeaBattleState;
    ReducerTradeIn: TradeInState;
}

export default combineReducers(reducers);
